import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 500px;
  min-width: 500px;
  max-height: calc(100%);
  height: auto;
  display: flex;
  flex-direction: column;
`;

function PageMenu({ children }: IPageMenu) {
  return <Wrapper>{children}</Wrapper>;
}

export interface IPageMenu {
  children: any;
}

export default PageMenu;
